import { Component, Input, inject } from '@angular/core';
import { MbbProduct } from '../../../models/mbb-product.model';
import { Store } from '@ngxs/store';
import { ApiGetMbbSubscriptionOfferingsAction } from '../../../states/customer-product-mbb.actions';
import { IconNames } from '@shared/enums/icon-names';
import { DatePipe } from '@angular/common';
import { ChangeMbbSubscriptionComponent } from './change-mbb-subscription/change-mbb-subscription.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mbb-existing-subscription',
  templateUrl: './mbb-existing-subscription.component.html',
  styleUrls: ['./mbb-existing-subscription.component.scss'],
  imports: [MatIcon, ChangeMbbSubscriptionComponent, DatePipe],
})
export class MbbExistingSubscriptionComponent {
  private store = inject(Store);

  @Input() product: MbbProduct;

  IconNames = IconNames;
  isChangingSubscription = false;

  changeSubscription(product: MbbProduct) {
    this.isChangingSubscription = true;
    this.store.dispatch(new ApiGetMbbSubscriptionOfferingsAction(product.existingSubscription.id));
  }

  changeSubscriptionClose() {
    this.isChangingSubscription = false;
  }
}
